// Колоните на Excel за „Продадени продукти/рецепти". Рецептите — както
// таблицата (и „Последна продажба" като в нея — дд.ММ.гггг чч:мм). Продуктите — всичко, което таблицата сгъва: по рецепта (к-во,
// ср. цена, нето, бруто), разнесено (к-во, нето, бруто, в т.ч. вместо друг
// продукт, покрито от друг) и разликата (к-во, нето, бруто). Докато реалното
// се зарежда, клетките му са празни.
import type { ExcelColumn } from "../../../../utils/excelExport";
import { fmtDateTime } from "../../components/dateTime";
import type { SoldRow } from "./soldVarianceModel";

type Translate = (key: string) => string;

export const soldExcelColumns = (isProduct: boolean, t: Translate): ExcelColumn<SoldRow>[] => {
  const key = (name: string) => t(`inventoryPage.${name}`);
  if (!isProduct) {
    return [
      { header: key("soldColName"), value: (row) => row.name },
      { header: key("soldColIngredients"), value: (row) => row.ingredientsCount },
      { header: key("soldColSold"), value: (row) => row.quantity },
      { header: key("soldColLastSold"), value: (row) => (row.lastSoldAt ? fmtDateTime(row.lastSoldAt) : null), width: 18 },
      { header: key("soldColAvgPrice"), value: (row) => row.avgPrice },
      { header: key("colNet"), value: (row) => row.sumNoVat },
      { header: key("colGross"), value: (row) => row.totalSum },
    ];
  }
  const recipe = key("sdGroupRecipe");
  const posted = key("sdGroupPosted");
  const diff = key("sdGroupDiff");
  const qty = key("sdColQty");
  const net = key("colNet");
  const gross = key("colGross");
  return [
    { header: key("soldColName"), value: (row) => row.name, width: 28 },
    { header: key("colUnit"), value: (row) => row.unit ?? "" },
    { header: `${recipe} · ${qty}`, value: (row) => row.quantity },
    { header: `${recipe} · ${key("soldColAvgPrice")}`, value: (row) => row.avgPrice },
    { header: `${recipe} · ${net}`, value: (row) => row.sumNoVat },
    { header: `${recipe} · ${gross}`, value: (row) => row.totalSum },
    { header: `${posted} · ${qty}`, value: (row) => row.actual?.quantity },
    { header: `${posted} · ${net}`, value: (row) => row.actual?.valueNoVat },
    { header: `${posted} · ${gross}`, value: (row) => row.actual?.valueWithVat },
    { header: key("sdXlsDonor"), value: (row) => row.actual?.donorQuantity || null, width: 20 },
    { header: key("sdXlsCovered"), value: (row) => row.actual?.coveredQuantity || null, width: 20 },
    { header: `${diff} · ${qty}`, value: (row) => row.variance?.quantity },
    { header: `${diff} · ${net}`, value: (row) => row.variance?.valueNoVat },
    { header: `${diff} · ${gross}`, value: (row) => row.variance?.valueWithVat },
  ];
};
